export const API_STATUS = "API_STATUS";
export const FETCH_LIMIT_ROWS = "FETCH_LIMIT_ROWS";
export const FETCH_AUDIT_ROWS = "FETCH_AUDIT_ROWS";
export const FETCH_LIMIT_DROPDOWN = "FETCH_LIMIT_DROPDOWN";
export const ADD_LIMIT = "ADD_LIMIT";
export const ADD_LIMIT_PARENT = "ADD_LIMIT_PARENT";
export const EXPORT_PDF_DATA = "EXPORT_PDF_DATA";
export const EXPORT_XL_DATA = "EXPORT_XL_DATA";
export const IMPORT_LIMIT_DATA = "IMPORT_LIMIT_DATA";
export const GET_PARA_LIST = "GET_PARA_LIST";
export const CLEAR_LIMIT_MESSAGE  = "CLEAR_LIMIT_MESSAGE ";
export const DELETELIMIT  = "DELETELIMIT";
export const UPDATELIMIT  = "UPDATELIMIT";
export const LIMITOPERATION  = "LIMITOPERATION";